// Global variables

var app = {};
var viewer;

// Domready

$(function () {
  // Remove fullscreen option on iOS devices
  if (isMobileDevice()) {
    $('body').addClass('is-mobile-device');
  }

  // Features
  if (isFeatureEnabled('issueAttachments')) {
    $('.edit-issue__add-attachments-wrapper').addClass('feature-attachments-enabled');
  }

  if (!isFeatureEnabled('issues')) {
    $('#panel-option-issues').css({ display: 'none' });
  }

  // Set admin
  if (getParameterByName('admin') === '' || window.location.hash === '#admin') {
    $('body').addClass('is-admin');
  }

  // Set isolate mode
  if (localStorage.getItem('isolate-mode') == '1') {
    activateIsolateMode();
  }

  // Set zoom mode
  if (localStorage.getItem('zoom-mode') == '1') {
    activateZoomMode();
  }

  // Update bookmarks button
  updateAddToBookmarkButton();
  updateBookmarkList();

  // Reset panels
  resetPanels();

  // Show project
  var urn = getParameterByName('urn');
  var isPublic = getParameterByName('public') === '';

  if (urn) {
    settings.features.issues = false;
  }

  // console.log(settings.whitelistPublicProjects, urn);

  if (isPublic && urn) {
    if (
      settings.requirePublicUser &&
      !isSignedIn() &&
      settings.whitelistPublicProjects.indexOf(urn) == -1
    ) {
      showLogin(true);
    } else if (
      settings.requirePublicButtonClick &&
      !isSignedIn()
    ) {
      showLogin(true, true);
    } else {
      app.public = true;
      showApp(true);
      launchViewer(urn);
    }
    return;
  }

  // Check if we are signed in
  app.public = false;

  $.ajax({
    url: '/api/forge/oauth/token',
    timeout: 6000,
    complete: function (response) {
      // Timeout occurs when token is invalid
      if (response && response.statusText === 'timeout') {
        forgeSignOut();
      }
    },
    success: function (response) {
      // We are signed in, show app
      showApp();

      var ids = getProjectIds();

      app.nodeId = ids.nodeId || urn;

      if (!isFeatureEnabled('protocolPanel')) {
        $('#panel-option-protocols').css({ display: 'none' });
      } else {
        initProtocols();
      }

      if (app.nodeId) {
        launchViewer(app.nodeId);

        // Prepare hubs, show user
        prepareUserHubsTree();
        showUser();
      } else {
        error();
      }
    },
    error: function () {
      // We are not signed in, show sign in page
      showLogin();
    }
  });
});

// Show app or login

function showApp(isPublic) {
  $('.app__wrapper').addClass('app-active' + (isPublic ? ' app-public' : ''));
  $('.signin__wrapper').removeClass('app-active').removeClass('app-public');
}

function showLogin(isPublic, requireButtonClick) {
  $('.app__wrapper').removeClass('app-active').removeClass('app-public');
  $('.signin__wrapper').addClass('app-active' + (isPublic ? ' app-public' : '')).removeClass('app-require-button-click');

  if (requireButtonClick) {
    $('.signin__wrapper').addClass('app-require-button-click');
  }
}

// Sign out
// Learn more about this signout iframe at
// https://forge.autodesk.com/blog/log-out-forge

function forgeSignOut() {
  localStorage.setItem('__psi', null);

  $('#hiddenFrame').on('load', function (event) {
    location.href = '/api/forge/oauth/signout';
  });
  $('#hiddenFrame').attr('src', 'https://accounts.autodesk.com/Authentication/LogOut');
}

// Sign in

function forgeSignIn() {

  // Public signin
  if ($('.signin__wrapper').hasClass('app-public')) {
    let signInCheck = false;

    // Public sign in no user needed
    if ($('.signin__wrapper').hasClass('app-require-button-click')) {
      signInCheck = true;
    } else {
      var usernameInput = $('.signin__textfield--username').val();
      var passwordInput = $('.signin__textfield--password').val();

      $.each(settings.users, function (username, password) {
        if (usernameInput === username && CryptoJS.MD5(passwordInput).toString() === password) {
          signInCheck = true;
          return false;
        }
      });
    }

    if (!signInCheck) {
      animateEl($('.signin__button'), 'shake');
    } else {
      if ($('.signin__wrapper').hasClass('app-require-button-click')) {
        localStorage.setItem('__psi', getSignedInHash('app-require-button-click', '1'));
      } else {
        localStorage.setItem('__psi', getSignedInHash(usernameInput, CryptoJS.MD5(passwordInput).toString()));
      }
      window.location.reload();
    }
    return;
  }

  // Forge sign in
  jQuery.ajax({
    url: '/api/forge/oauth/url',
    success: function (url) {
      location.href = url;
    }
  });
}

// Check for access token

function getForgeToken(callback) {
  if (app.public) {
    getForgeTokenPublic(callback);
    return;
  }
  fetch('/api/forge/oauth/token').then((res) => {
    res.json().then((data) => {
      callback(data.access_token, data.expires_in);
    });
  });
}

// Get public access token for read only

function getForgeTokenPublic(callback) {
  jQuery.ajax({
    url: '/api/forge/oauth/public',
    success: function (res) {
      callback(res.access_token, res.expires_in);
    }
  });
}

// Show the user

function showUser() {
  $.ajax({
    url: '/api/forge/user/profile',
    success: function (profile) {
      $('.nav__user').html(profile.name);
    }
  });
}

// Projects tree

function toggleProjectsTree() {
  $('.projects__wrapper, .nav__toggle-projects').toggleClass('projects-active');
  $('.nav__toggle-projects')[$('.projects__wrapper').hasClass('projects-active') ? 'addClass' : 'removeClass'](
    'nav-icon-active'
  );
  $('.nav__refresh-tree').toggleClass('refresh-active');
}

function closeProjectsTree() {
  $('.projects__wrapper, .nav__toggle-projects').removeClass('projects-active');
  $('.nav__toggle-projects').removeClass('nav-icon-active');
  $('.nav__refresh-tree').removeClass('refresh-active');
}

function refreshProjectsTree() {
  $('#userHubs').jstree(true).refresh();
}

// Fullscreen

function toggleFullscreen() {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    $('.nav__fullscreen').addClass('is-fullscreen');
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
      $('.nav__fullscreen').removeClass('is-fullscreen');
    }
  }
}

// Check if on iPad

// function isIOS() {
//   if (/iPad|iPhone|iPod/.test(navigator.platform)) {
//     return true;
//   } else {
//     return (
//       navigator.maxTouchPoints &&
//       navigator.maxTouchPoints > 2 &&
//       /MacIntel/.test(navigator.platform)
//     );
//   }
// }

// Toggle settings

function toggleSettings() {
  $('body').toggleClass('settings-active');
  $('.nav__settings').toggleClass('nav-icon-active');
}

function closeSettings() {
  $('body').removeClass('settings-active');
  $('.nav__settings').removeClass('nav-icon-active');
}

// Toggle isolate mode

function toggleIsolateMode() {
  var currentStatus = localStorage.getItem('isolate-mode');
  if (!currentStatus || currentStatus == '0') {
    activateIsolateMode();
  } else {
    deactivateIsolateMode();
  }
}

function activateIsolateMode() {
  localStorage.setItem('isolate-mode', '1');
  $('.settings__icon--isolate').removeClass('icon-toggle-off').addClass('icon-toggle-on').addClass('isolate-active');

  if (viewer) {
    selectPanelListItems(viewer);
  }
}

function deactivateIsolateMode() {
  localStorage.setItem('isolate-mode', '0');
  $('.settings__icon--isolate').removeClass('icon-toggle-on').addClass('icon-toggle-off').removeClass('isolate-active');

  if (viewer) {
    selectPanelListItems(viewer);
  }
}

// Toggle zoom mode

function toggleZoomMode() {
  var currentStatus = localStorage.getItem('zoom-mode');
  if (!currentStatus || currentStatus == '0') {
    activateZoomMode();
  } else {
    deactivateZoomMode();
  }
}

function activateZoomMode() {
  localStorage.setItem('zoom-mode', '1');
  $('.settings__icon--zoom').removeClass('icon-toggle-off').addClass('icon-toggle-on').addClass('zoom-active');

  if (viewer) {
    selectPanelListItems(viewer, true);
  }
}

function deactivateZoomMode() {
  localStorage.setItem('zoom-mode', '0');
  $('.settings__icon--zoom').removeClass('icon-toggle-on').addClass('icon-toggle-off').removeClass('zoom-active');
}

// Manually zoom in

function manualZoomIn() {
  if (!viewer) {
    return;
  }
  selectPanelListItems(viewer, true);
}

// Manually flip isolation mode

function manualFlipIsolation() {
  if (!viewer) {
    return;
  }
  $('.viewer-button.icon-flip').toggleClass('flip-active');
  selectPanelListItems(viewer, false);
}

// Toggle bookmark

function toggleBookmark() {
  const ids = getProjectIds();

  if (getProjectFromBookmarks(ids.nodeId)) {
    removeFromBookmarks(ids.nodeId);
  } else {
    addToBookmarks();
  }
}

// Add current project to bookmarks

function addToBookmarks() {
  const ids = getProjectIds();

  if (getProjectFromBookmarks(ids.nodeId)) {
    return true;
  }

  if (app.addingToBookmarks) {
    return false;
  }

  const bookmarks = getBookmarks();
  let name = localStorage.getItem('bookmarkName');

  const setNameAndAddBookmark = function (ids, bookmarks, name) {
    ids.name = name;
    bookmarks.unshift(ids);
    localStorage.setItem('bookmarks', JSON.stringify(bookmarks));
    localStorage.setItem('bookmarkName', name);
    updateAddToBookmarkButton();
    updateBookmarkList();
  };

  if (name) {
    setNameAndAddBookmark(ids, bookmarks, name);
  } else {
    getBookmarkName('', 'Name of bookmark', function (name) {
      setNameAndAddBookmark(ids, bookmarks, name);
    });
    return;
  }
}

// Get the name for a bookmark

function getBookmarkName(name, title, callback) {
  new jBox('Modal', {
    addClass: 'modal-bim360 modal-bim360--title-left',
    title: title,
    closeButton: 'title',
    content:
      '<div class="bookmark_edit-name-container"><input type="text" class="textfield" placeholder="Choose a name for the bookmark"><button class="button">' + __('saveButton') + '</button></div>',
    closeOnClick: false,
    onCreated: function () {
      updateModalCloseIcon(this.wrapper);

      const inputField = this.content.find('.textfield');
      const button = this.content.find('.button');

      if (name) {
        inputField.val(name);
      } else {
        inputField.focus();
      }

      button.on(
        'click',
        function () {
          const inputName = inputField.val().trim();
          if (!inputName) {
            error('Please type in the name of the bookmark');
            animateEl(button, 'shake');
            return;
          }
          callback(inputName);
          this.close();
        }.bind(this)
      );
    },
    onCloseComplete: function () {
      this.destroy();
    }
  }).open();
}

// Edit a bookmark

function editBookmark(nodeId) {
  const project = getProjectFromBookmarks(nodeId);

  if (!getProjectFromBookmarks(nodeId)) {
    error();
    return false;
  }

  getBookmarkName(project.name, 'Name of bookmark', function (name) {
    const bookmarks = getBookmarks();

    for (var i = 0; i < bookmarks.length; i++) {
      if (bookmarks[i].nodeId == nodeId) {
        bookmarks[i].name = name;
      }
    }
    localStorage.setItem('bookmarks', JSON.stringify(bookmarks));
    updateBookmarkList();
  });
}

// Remove current or a specific project from bookmarks

function removeFromBookmarks(nodeId) {
  const ids = getProjectIds();
  if (!nodeId) {
    nodeId = ids.nodeId;
  }

  if (!getProjectFromBookmarks(nodeId)) {
    return true;
  }

  const bookmarks = getBookmarks();
  const newBookmarks = [];

  for (var i = 0; i < bookmarks.length; i++) {
    if (bookmarks[i].nodeId != nodeId) {
      newBookmarks.push(bookmarks[i]);
    }
  }

  localStorage.setItem('bookmarks', JSON.stringify(newBookmarks));
  updateAddToBookmarkButton();
  updateBookmarkList();
}

// Remove bookmark from panel list

function removeBookmark(nodeId) {
  if (!getProjectFromBookmarks(nodeId)) {
    return true;
  }

  $('.bookmark__container[data-id="' + nodeId + '"]').fadeOut(200, function () {
    removeFromBookmarks(nodeId);
  });
}

// Update the bookmarks button

function updateAddToBookmarkButton() {
  const ids = getProjectIds();

  if (getProjectFromBookmarks(ids.nodeId)) {
    $('.settings__icon--bookmarks').addClass('icon-bookmark bookmark-active').removeClass('icon-bookmark-outline');
    $('.settings__button--bookmarks .settings__label').html(__('menuRemoveBookmark'));
  } else {
    $('.settings__icon--bookmarks').addClass('icon-bookmark-outline').removeClass('icon-bookmark bookmark-active');
    $('.settings__button--bookmarks .settings__label').html(__('menuAddToBookmarks'));
  }
}

// Update bookmark list

function updateBookmarkList() {
  const bookmarks = getBookmarks();

  $('.bookmarks__container').removeClass('no-bookmarks');
  $('.bookmarks__list').html('');

  if (!bookmarks || !bookmarks.length) {
    $('.bookmarks__container').addClass('no-bookmarks');
    return;
  }

  const ids = getProjectIds();
  const urn = getParameterByName('urn');

  for (var i = 0; i < bookmarks.length; i++) {
    const bookmark = bookmarks[i];
    const isActive = !urn && ids.nodeId == bookmark.nodeId;
    const wrapper = $('<div class="bookmark__container' + (isActive ? ' bookmark__container--active' : '') + '"/>');
    wrapper.attr('data-id', bookmark.nodeId);
    const container = $('<div class="bookmark__button" onclick="loadBookmark(\'' + bookmark.nodeId + '\')"/>');
    wrapper.append(container);
    container.append($('<div class="bookmark__icon icon-radio-button' + (isActive ? '-checked' : '') + '"/>'));
    container.append($('<div class="bookmark__name"/>').html(bookmark.name));
    wrapper.append(
      $('<div class="bookmark__edit-button icon-edit" onclick="editBookmark(\'' + bookmark.nodeId + '\')"/>')
    );
    wrapper.append(
      $('<div class="bookmark__remove-button icon-clear" onclick="removeBookmark(\'' + bookmark.nodeId + '\')"/>')
    );
    $('.bookmarks__list').append(wrapper);
  }
}

// Load a bookmark

function loadBookmark(nodeId) {
  const ids = getProjectFromBookmarks(nodeId);

  if (!ids || !ids.hubId || !ids.projectId || !ids.nodeId || !ids.name) {
    error();
  }

  return setProjectAndReload(ids.hubId, ids.projectId, ids.nodeId, ids.name);
}

// Set project and reload page

function setProjectAndReload(hubId, projectId, nodeId, bookmarkName) {
  localStorage.setItem('hubId', hubId);
  localStorage.setItem('projectId', projectId);
  localStorage.setItem('nodeId', nodeId);
  localStorage.setItem('bookmarkName', bookmarkName || '');
  window.location.href = '/';
}

// Get the bookmarks from local storage

function getBookmarks() {
  if (!localStorage.getItem('bookmarks')) {
    return [];
  }
  return JSON.parse(localStorage.getItem('bookmarks'));
}

// Get the ids from current or a specific project is bookmarked

function getProjectFromBookmarks(nodeId) {
  const ids = getProjectIds();
  if (!nodeId) {
    nodeId = ids.nodeId;
  }

  const bookmarks = getBookmarks();
  let bookmarkedProject = null;

  for (var i = 0; i < bookmarks.length; i++) {
    if (bookmarks[i].nodeId == nodeId) {
      bookmarkedProject = bookmarks[i];
    }
  }

  return bookmarkedProject;
}

// Get the project ids to use

function getProjectIds() {
  const initial = {
    nodeId: settings.initialNodeId,
    hubId: settings.initialHubId,
    projectId: settings.initialProjectId
  };

  const local = {
    nodeId: localStorage.getItem('nodeId'),
    hubId: localStorage.getItem('hubId'),
    projectId: localStorage.getItem('projectId')
  };


  if (local.nodeId && local.hubId && local.projectId) {

    local.hubIdDecoded = decodeAutodeskURN(local.nodeId);

    return local;
  }

  initial.hubIdDecoded = decodeAutodeskURN(initial.nodeId);

  return initial;
}

function decodeAutodeskURN(urn) {
  // Replace URL-safe base64 characters
  const base64 = urn.replace(/_/g, '/').replace(/-/g, '+');

  // Pad base64 string if needed
  const padded = base64 + '==='.slice((base64.length + 3) % 4);

  return atob(padded);
}

// Toggle Project details

function openProjectDetails() {
  $('body').addClass('project-details-open');
  closeSettings();
}

function closeProjectDetails() {
  $('body').removeClass('project-details-open');
}
